import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { AuthorizableProfile, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

// The owner profiles the current user may authorize an AI client against. A 403 means
// the user owns no gym — only owners can connect, so surface it rather than retrying.
export default function useAuthorizableProfiles(
  enabled = true,
): UseQueryResult<AxiosResponse<AuthorizableProfile[]>, AxiosError<ErrorMessage>> {
  return useQuery(['mcp-authorizable-profiles'], () => client.get('mcp/authorizable-profiles/'), {
    enabled,
    retry: false,
  });
}
